import { useFormat } from 'helpers/hooks/useFormat';
import CartItemsList from './cart-items-list';
import EmptyCart from './empty-cart';
import { CartProps } from '../types';

type Props = CartProps & {
  className?: string;
};

const CartContent = ({ className, isEmpty, totalItems, cart, onRemoveItem, onUpdateItem }: Props) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className={className}>
      {!isEmpty ? (
        <div>
          <div className="flex items-center justify-between">
            <h3 className="text-[16px] md:text-[18px] lg:text-[22px]">
              {formatMessage({ id: 'cart.title', defaultMessage: 'Carrello' })}
              <span className="ms-1 text-secondary-black">
                ({totalItems} {formatMessage({ id: 'cart.items', defaultMessage: 'Articoli' })})
              </span>
            </h3>
          </div>
          <CartItemsList cart={cart} onRemoveItem={onRemoveItem} onUpdateItem={onUpdateItem} />
        </div>
      ) : (
        <EmptyCart />
      )}
    </div>
  );
};

export default CartContent;
